import { Component, Input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-dashboard-stat-card',
  imports: [TranslateModule],
  templateUrl: './dashboard-stat-card.html',
  styleUrl: './dashboard-stat-card.scss',
})
export class DashboardStatCard {
  @Input({ required: true }) titleKey = '';
  @Input({ required: true }) value: string | number = '0';
  @Input() iconClass = 'fa-solid fa-chart-simple';
  @Input() accent: 'primary' | 'info' | 'success' | 'warning' | 'danger' | 'secondary' = 'primary';
}
